import type { ElementType, PropsWithChildren } from 'react';
import type { FormHelperTextProps } from '@mui/material';
import { FormHelperText } from '@mui/material';
import DoneCircleBoldIcon from '@/ui/kit/icons/done-circle-bold.svg';
import ForbidenBoldIcon from '@/ui/kit/icons/forbiden-bold.svg';
import InfoCircleBoldIcon from '@/ui/kit/icons/info-circle-bold.svg';
interface IHelperTextContent {
  type?: 'simple' | 'info' | 'success' | 'error';
  icon?: ElementType;
  iconColor?: string;
}
export type HelperTextContentProps = PropsWithChildren<IHelperTextContent>;
const defaultIcons: { [key in Exclude<IHelperTextContent['type'], undefined>]: ElementType | null } = {
  simple: null,
  info: InfoCircleBoldIcon,
  error: ForbidenBoldIcon,
  success: DoneCircleBoldIcon
};
export const HelperTextContent = ({
  children,
  icon,
  iconColor,
  type = 'info'
}: HelperTextContentProps) => {
  const iconComponent = icon || defaultIcons[type];
  const defaultColor = type === 'success' ? 'success.main' : undefined;
  const color = iconColor ? iconColor : defaultColor;
  return <>
      {/* {!!iconComponent && children !== ' ' && (
        <SvgIcon
          component={iconComponent}
          fontSize='small'
          sx={{
            color,
            verticalAlign: 'middle',
            marginRight: 1,
          }}
        />
       )} */}
      {children === ' ' ? <>&#8203;</> : children}
    </>;
};
export type HelperTextProps = FormHelperTextProps & HelperTextContentProps;
export const HelperText = ({
  children,
  type,
  icon,
  iconColor,
  ...restProps
}: HelperTextProps) => {
  return <FormHelperText error={type === 'error'} {...restProps} data-sentry-element="FormHelperText" data-sentry-component="HelperText" data-sentry-source-file="HelperText.tsx">
      <HelperTextContent icon={icon} iconColor={iconColor} type={type} data-sentry-element="HelperTextContent" data-sentry-source-file="HelperText.tsx">
        {children}
      </HelperTextContent>
    </FormHelperText>;
};